import { FC } from 'react';
import { BeatLoader } from 'react-spinners';

interface IProps {
  text?: string;
  height?: string;
  color?: string;
  position?: string;
  className?: string;
  size?: number;
}

const Spinner: FC<IProps> = ({
  text = '',
  height = '100vh',
  color = 'var(--green-main)',
  position = 'center',
  className,
  size = 10,
}) => {
  return (
    <div
      className={className ? className : ''}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: `${position}`,
        color: color,
        height: height,
      }}
    >
      <BeatLoader size={size} color="var(--primary)" />
      <p className="mt-3">{text}</p>
    </div>
  );
};

export default Spinner;
